import {
    DataProviderEntitySaveActionLinkInterface,
    DataProviderEntitySaveActionParamInterface
} from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionParamInterface";
import {Component} from "vue";
import DataProviderEntitySaveActionBlockForm
    from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionBlockForm.vue";
import Random from "~/ts/library/Random";
import {
    DataProviderEntitySaveActionDescriptionFrontendParamsInterface,
    DataProviderLinkEntityTypeInterface
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/Interface";
import AbstractDataProviderEntityActionDescription
    from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/AbstractDataProviderEntityActionDescription";
import Dictionary from "~/ts/library/Dictionary";
import {
    SearchTypeInterface
} from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionParamInterface";
import DataProviderEntitySaveActionBlockPreview
    from "~/cabinet/vue/client/events/action/types/dataProvider/entity/save/DataProviderEntitySaveActionBlockPreview.vue";


export class DataProviderEntitySaveActionDescription extends AbstractDataProviderEntityActionDescription<DataProviderEntitySaveActionParamInterface, DataProviderEntitySaveActionDescriptionFrontendParamsInterface> {
    get dataProviderActionFormComponent(): Component {
        return DataProviderEntitySaveActionBlockForm;
    }

    get previewComponent(): Component {
        return DataProviderEntitySaveActionBlockPreview;
    }


    getDefaultModelValues(linkType?: DataProviderLinkEntityTypeInterface): DataProviderEntitySaveActionParamInterface {
        let searchModes = linkType ? linkType.searchModes : this.frontendParams.searchModes;
        let searchTypes: Dictionary<SearchTypeInterface> = {};
        for (let item of searchModes) {
            if (item.isDefault) {
                searchTypes[item.id] = {
                    enabled: true,
                    value: item.defaultValue,
                    fieldId: item.fieldId,
                    valueTypeId: item.fieldId ? "field" : "static"
                };
            }
        }
        return {
            ...super.getAbstractDefaultModelValues(),
            foundActionMode: this.frontendParams.actionModes.found[0]!.id,
            notFoundActionMode: this.frontendParams.actionModes.notFound[0]!.id,
            isAlwaysCreate: false,
            searchTypes,
            fields: [],
            updateFilters: [],
            additionalConfigFormValues: {},
            links: this.frontendParams.linkEntityTypes
                .filter(type => type.isLinkedByDefault)
                .map(type => {
                    let result: DataProviderEntitySaveActionLinkInterface = {
                        id: Random.uid(),
                        entityTypeId: type.id,
                        value: undefined,
                        additionalConfigFormValues: {}
                    };
                    return result;
                })
        };
    }
}
